import gql from 'graphql-tag';
import {
  analyticArguments,
  analyticArgumentsOfflineMedia,
  analyticArgumentsOnlineMedia,
  analyticArgumentsQuery,
  analyticArgumentsQueryOfflineMedia,
  analyticArgumentsQueryOnlineMedia
} from '../analyticArgument';

export const DOWNLOAD_CSV = gql`
  mutation download_createDownloadCsvJob(${analyticArgumentsQuery}, $email: String!, $templateName: DownloadTemplate, $exportType: ExportType) {
    download_createDownloadCsvJob(${analyticArguments}, email: $email, templateName: $templateName, exportType: $exportType ) {
      id
      start
      end
      objectIdList
      status
      createdAt
    }
  }
`;

export const DOWNLOAD_CSV_JOB_FOR_MEDIA_ONLINE = gql`
  mutation download_createDownloadCsvJobForOnlineMedia(${analyticArgumentsQueryOnlineMedia}, $exportType: ExportType) {
    download_createDownloadCsvJobForOnlineMedia(${analyticArgumentsOnlineMedia}, exportType: $exportType) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
    }
  }
`;

export const DOWNLOAD_CSV_JOB_FOR_MEDIA_OFFLINE = gql`
  mutation download_createDownloadCsvJobForOfflineMedia(
    ${analyticArgumentsQueryOfflineMedia},
    $exportType: ExportType
  ) {
    download_createDownloadCsvJobForOfflineMedia(
      ${analyticArgumentsOfflineMedia},
      exportType: $exportType
    ) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
    }
  }
`;

export const DOWNLOAD_SUMMARY_ONLINE_MEDIA = gql`
  mutation download_createDownloadSummaryOnlineMedia(
  ${analyticArgumentsQueryOnlineMedia},
  $page: Int!, 
  $limit: Int!,
  $logoUrl: String,
  $language: String,
  $footerTitle: String,
  $footerAddress: String
  ) {
    download_createDownloadSummaryOnlineMedia(
    ${analyticArgumentsOnlineMedia},
    page: $page, 
    limit: $limit,
    logoUrl: $logoUrl,
    language: $language,
    footerTitle: $footerTitle,
    footerAddress: $footerAddress
    ) {
      id
      start
      end
      mediaList
      phrase
      status
      createdAt
      link
      clippingId
    }
  }
`;

export const DOWNLOAD_SUMMARY_REPORT = gql`
  mutation Download_createDownloadSummary(
    $projectId: Id!
    $start: Timestamp!
    $end: Timestamp!
    $page: Int!
    $limit: Int!
    $socialMediaInput: SocialMediaInput
    $onlineMediaInput: OnlineMediaInput
    $printMediaInput: OfflineMediaInput
    $broadcastMediaInput: OfflineMediaInput
    $logoUrl: String
    $title: String
  ) {
    download_createDownloadSummary(
      projectId: $projectId
      start: $start
      end: $end
      page: $page
      limit: $limit
      socialMediaInput: $socialMediaInput
      onlineMediaInput: $onlineMediaInput
      printMediaInput: $printMediaInput
      broadcastMediaInput: $broadcastMediaInput
      logoUrl: $logoUrl
      title: $title
    ) {
      id
      title
      start
      end
      status
      createdAt
      link
    }
  }
`;

// export const DOWNLOAD_CSV_MEDIA_OFFLINE = gql`
//   mutation download_createDownloadCsvJobForOfflineMedia(${analyticArgumentsQueryMediaOffline}) {
//     download_createDownloadCsvJobForOfflineMedia(${analyticArgumentsMediaOffline}) {
//       id
//       start
//       end
//       mediaList
//       phrase
//       status
//       createdAt
//       link
//     }
//   }
// `;
